import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ColorPicker from 'components/kea/ColorPicker';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import * as a from '../../../../../actions';
import styles from '../RecommendationSettings.module.scss';

const COLORS = [
  { key: 'widget-title-color', labelKey: 'recommendations.settings.theme.widgetTitle' },
  { key: 'widget-product-name-color', labelKey: 'recommendations.settings.theme.productName' },
  { key: 'widget-product-second-color', labelKey: 'recommendations.settings.theme.accent' },
  { key: 'widget-product-btn', labelKey: 'recommendations.settings.theme.buttonBackground' },
  { key: 'widget-product-btn-color', labelKey: 'recommendations.settings.theme.buttonText' },
  { key: 'widget-product-price-color', labelKey: 'recommendations.settings.theme.price' },
  { key: 'widget-product-oldprice-color', labelKey: 'recommendations.settings.theme.salePrice' },
  { key: 'widget-mobile-dots-color', labelKey: 'recommendations.settings.theme.pagination' },
];

const Theme = ({ onDirty }) => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const theme = useSelector(store => store.settings.recs?.theme || {});

  const changeColor = (key, value) => {
    dispatch(a.changeRecsThemeSetting(key, value));
    onDirty();
  };

  return (
    <section className={styles.card} data-testid="recommendation-color-settings">
      <div className={styles.cardHeader}>
        <div>
          <h2>{localizeMessage('recommendations.settings.theme.title')}</h2>
          <p>{localizeMessage('recommendations.settings.theme.hint')}</p>
        </div>
      </div>
      <div className={styles.colorGrid}>
        {COLORS.map(({ key, labelKey }) => {
          const value = theme[key] || '#000000';
          return (
            <div className={styles.colorCard} key={key} data-testid={`recommendation-color-${key}`}>
              <div className={styles.colorText}>
                <h3>{localizeMessage(labelKey)}</h3>
                <p>{localizeMessage('recommendations.settings.theme.colorHint')}</p>
              </div>
              <div className={styles.colorControl}>
                <code>{value.toUpperCase()}</code>
                <div className={styles.colorSwatch}>
                  <ColorPicker value={value} onChange={nextValue => changeColor(key, nextValue)} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

Theme.propTypes = {
  onDirty: PropTypes.func,
};

Theme.defaultProps = {
  onDirty: () => {},
};

export default Theme;
